import { Container, makeStyles, TextField, Typography } from "@material-ui/core";
import { blue, } from "@material-ui/core/colors";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startSync } from "../action/studentSelectAction";
import { dashboardRef } from "../firebase/firebaseModel";

const useStyles = makeStyles({
    container: {
        minHeight: "100vh",
        height: "fit-content",
        minWidth: "515px",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "20px",
        padding: "50px 30px",
    },
    error: {
        color: "red",
    },
    textArea: {
        minWidth: "500px",
        width: "100%",
        fontSize: "100px",
    },
    wrapper: {
        display: "flex",
        gap: "20px"
    }
});

export default function AnswerPage() {
    let classes = useStyles();
    let studentSelectState = useSelector(state => state.studentSelectState);
    let dispatch = useDispatch();
  
    let [userAnswer,setUserAnswer] = useState("");
    let updateAnswer = (answer)=>{
        let teacherID = studentSelectState.teacherID;
        let studentID = studentSelectState.selectedStudent.id;
       dispatch(startSync(teacherID,studentID,answer))
    }
    useEffect(()=>{
        dashboardRef.doc(studentSelectState.teacherID).collection("Student").doc(studentSelectState.selectedStudent.id).onSnapshot(async(snap)=>{
          if(await snap.data().answer==="") setUserAnswer("");
        })
         // eslint-disable-next-line 
    },[])
    return (
        <Container className={classes.container} fixed>
            <Typography variant="h6">
                {studentSelectState.selectedStudent.name}
            </Typography>
            <Typography variant="h3" >
                My Answer
            </Typography>
            <Typography variant="h6" >
                Enter your answer below. The text is visible for the teacher.
            </Typography>
            <TextField
                className={classes.textArea}
                multiline
                defaultValue=""
                rows={15}
                variant="outlined"
                value={userAnswer}
                onChange={(e)=>{
                    setUserAnswer(e.target.value);
                    updateAnswer(e.target.value);
                }}
            />
          <Typography variant="subtitle2" style={{color:blue[900] , marginTop:"-20px"}}> {studentSelectState.synced&&"Sync Complete"} {studentSelectState.syncronizing&&"Syncronizing . . ."}</Typography>
        </Container>

    )
}